import { makeStyles } from 'tss-react/mui'

const useStyles = makeStyles()((theme: any) => ({
  main: {
    position: 'relative',
    padding: 10,
    marginBottom: 20,
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
  },
  webView: {
    background: theme.webView.background,
  },
  statusHeader: {
    marginLeft: 15,
    marginBottom: 15,
    fontSize: 20,
  },
}))

export default useStyles
